import React from 'react';
import PropTypes from 'prop-types';
import { Container, makeStyles, Typography } from '@material-ui/core';
import SpinnerComponent from '../../../components/SpinnerComponent';
import ImageCard from './ImageCard';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2.5),
    margin: theme.spacing(3, 0),
  },
  cardContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2.5),
  },
  placeholder: {
    padding: theme.spacing(2),
    fontStyle: 'italic',
  },
}));

const ImageList = (props) => {
  const classes = useStyles();

  return (
    <Container maxWidth="md" className={classes.root}>
      <Typography variant="h6">Immagini caricate</Typography>
      <div className={classes.cardContainer}>
        {props.loading ? (
          <SpinnerComponent size={32} />
        ) : props.immagini.length === 0 ? (
          <Typography className={classes.placeholder} color="textSecondary">
            Nessuna immagine caricata
          </Typography>
        ) : (
          props.immagini.map((item) => (
            <ImageCard
              key={item.id}
              image={item}
              index={item.posizione}
              onChangeField={props.onChangeField}
              onRemoveAttachment={props.onRemoveAttachment}
              urlPath={props.urlPath}
            />
          ))
        )}
      </div>
    </Container>
  );
};

ImageList.propTypes = {
  loading: PropTypes.bool,
  immagini: PropTypes.array,
  onChangeField: PropTypes.func,
  onRemoveAttachment: PropTypes.func,
  urlPath: PropTypes.string,
};

export default ImageList;
